'use client'

import { useEffect } from 'react'
import AOS from 'aos'

import MaintenanceImg from '@/assets/images/maintenanceimg.webp'
import { PrimaryGradientButton } from '@/components/buttons'
import Link from '@/components/Link'

/**
 * The bare Maintenance panel, without the surrounding `<main>` landmark.
 *
 * Exported so callers that already sit inside a `<main>` (the AppShell error
 * boundary) can reuse the exact same visual treatment without nesting a second
 * landmark. `title` and `action` override the copy and the CTA; left unset it
 * renders the standard maintenance message and the "Back to home" button.
 */
export const MaintenanceContent = ({
  isComingSoon = false,
  title,
  action
}: {
  isComingSoon?: boolean
  title?: React.ReactNode
  action?: React.ReactNode
}) => {
  return (
    <div className="d-flex flex-column center-content text-align-center justify-content-center align-items-center px-3 px-md-0">
      <img
        src={MaintenanceImg.src}
        alt="Site under maintenance"
        style={{ maxHeight: '45vh', width: 'auto', maxWidth: '100%' }}
      />

      {title ? (
        <h1 className="maintenance-title" style={{ fontSize: '1rem', fontWeight: 'normal' }}>
          {title}
        </h1>
      ) : isComingSoon ? (
        <h1 className="maintenance-title" style={{ fontSize: '1rem', fontWeight: 'normal' }}>
          Coming soon! Stay tuned for more updates.
        </h1>
      ) : (
        <h1 className="maintenance-title" style={{ fontSize: '1rem', fontWeight: 'normal' }}>
          Oops! Our site is under construction. We'll be back with more exciting products.
        </h1>
      )}

      {!isComingSoon && (
        <h2
          className="maintenance-subtitle"
          style={{ color: 'black', fontSize: '1.25rem', fontWeight: '500' }}
        >
          <span>Contact us at</span>
          <a href="tel:+60323326000" style={{ color: '#221AFB', textDecoration: 'none' }}>
            {' '}
            +603-2332 6000 (Customer Support)
          </a>{' '}
          or visit
          <a
            href="https://www.alrajhibank.com.my"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#221AFB', textDecoration: 'none' }}
          >
            {' '}
            alrajhibank.com.my
          </a>{' '}
          for more information.
        </h2>
      )}

      <div style={{ paddingTop: '64px' }}>
        {action ?? (
          <Link href="/" style={{ textDecoration: 'none' }}>
            <PrimaryGradientButton text="Back to home" />
          </Link>
        )}
      </div>
    </div>
  )
}

const Maintenance = ({ isComingSoon = false }) => {
  useEffect(() => {
    AOS.init()
  }, [])

  return (
    <main className="main section container">
      <MaintenanceContent isComingSoon={isComingSoon} />
    </main>
  )
}

export default Maintenance
